import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

export interface MenuItem {
  label: string;
  route: string;
  disabled: boolean;
}

export interface PageType {
  manageListing: MenuItem[];
}

@Component({
  selector: 'msh-page-wrapper',
  standalone: true,
  imports: [RouterModule],
  template: `
  <div class="flex flex-col grow h-full  md:max-w-7xl md:mx-auto  ">
    <div class="md:flex h-full grow ">
      <div class=" h-full">
        <ng-content select="[left-side-bar]"></ng-content>
        <!-- Desktop layout -->
        <nav class="hidden md:flex py-3 flex-col font-light items-end pr-4 w-fit flex-shrink-0">
          @for(item of menuItems[page]; track item.label){
            <a
              [class]="'py-3 px-3 transition-colors duration-200 ' + (item.disabled ? ' opacity-50' : 'hover:text-orange-500')"
              [routerLink]="item.disabled ? null : item.route + (this.entityId ? '/'+this.entityId : '')"
              routerLinkActive="font-normal text-navy-800"
              [routerLinkActiveOptions]="{ exact: true }">
              {{ item.label }}
            </a>
          }
        </nav>
        <!-- Mobile layout -->
        <nav class="md:hidden font-light flex overflow-x-auto border-b shadow-sm">
          @for(item of menuItems[page]; track item.label){
            <a
              [class]="'whitespace-nowrap py-2 px-4 transition-colors duration-200 ' + (item.disabled ? ' opacity-50' : 'hover:text-orange-500')"
              [routerLink]="item.disabled ? null : item.route + (this.entityId ? '/'+this.entityId : '')"
              routerLinkActive="font-bold text-navy-800"
              [routerLinkActiveOptions]="{ exact: true }">
              {{ item.label }}
            </a>
          }
        </nav>
      </div>
      <div class="flex flex-1 flex-col md:min-w-[600px] max-w-[1024px] px-4 py-4 ">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  `,
  styles: [`:host { display: flex; flex-direction: column; flex-grow: 1; height: 100%;}`]
})
export class WrapperPageComponent implements OnChanges {
  
  @Input() entityId: string = '';
  @Input() page: keyof PageType | '_empty_' = '_empty_';
  @Input() disabledList: string[] = [];
  menuItems: {[page in keyof PageType | '_empty_']:MenuItem[]} = {
    manageListing: [
      { label: 'Photos', route: '/manage-listing/photos', disabled: false },
      { label: 'Details', route: '/manage-listing/details', disabled: false },
      { label: 'Price & Stock', route: '/manage-listing/price-stock', disabled: false },
      { label: 'Delivery', route: '/manage-listing/delivery', disabled: false },
      { label: 'Status', route: '/manage-listing/status', disabled: false}
    ],
    _empty_: [],
  };

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    console.log({changes})
    if(changes["disabledList"]){
      this.menuItems[this.page].forEach(item=>{
        item.disabled = this.disabledList.includes(item.label)
      })
    }
  }

}
